module.exports = __webpack_public_path__ + "img/electric-mining-drill-E-drill-received-shadow.85fa0813.png";